"use strict";
(self["webpackChunkgrafana"] = self["webpackChunkgrafana"] || []).push([[7004],{

/***/ 21396:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "static/img/AI_Logo_color.1dc03fee.svg";

/***/ })

}]);